import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 400px;
   display: flex;
   flex-direction: column;
   gap: 1rem;

   .section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
   }

   .label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #333;
      margin-bottom: 0.25rem;
   }

   .status-container {
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 1rem;
   }

   .qr-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
   }

   .qr-code {
      background: white;
      padding: 1rem;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
         max-width: 200px;
         max-height: 200px;
         display: block;
      }
   }

   .status-text {
      font-size: 0.875rem;
      color: #666;
      text-align: center;

      &.error {
         color: #ef4444;
      }
   }

   .status-connected {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      justify-content: center;
   }

   .status-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #10b981;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: bold;
   }

   .phone-number {
      font-size: 0.75rem;
      color: #999;
      margin-top: 0.25rem;
   }

   .helper-text {
      font-size: 0.75rem;
      color: #666;
      line-height: 1.5;
      text-align: center;
      max-width: 300px;
   }

   .modeRow {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      font-size: 0.85rem;

      label {
         display: flex;
         align-items: center;
         gap: 0.5rem;
      }
   }

   .toggleRow {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.85rem;
   }

   .directionRow {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
      font-size: 0.85rem;

      label {
         display: inline-flex;
         align-items: center;
         gap: 0.45rem;
      }
   }

   .groupsToolbar {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
   }

   .smallBtn {
      border: 1px solid #d1d5db;
      background: #fff;
      border-radius: 6px;
      font-size: 0.75rem;
      padding: 0.35rem 0.6rem;
      cursor: pointer;
      color: #1f2937;
   }

   .smallBtn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
   }

   .smallBtn.clear {
      border-color: #fca5a5;
      color: #991b1b;
   }

   .testMessageRow {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      input[type="text"] {
         border: 1px solid #d1d5db;
         border-radius: 6px;
         padding: 0.45rem 0.6rem;
         font-size: 0.8rem;
         color: #1f2937;
         width: 100%;
         box-sizing: border-box;

         &:focus {
            outline: none;
            border-color: #93c5fd;
         }
      }

      .smallBtn {
         align-self: flex-start;
      }
   }

   .syncMeta {
      font-size: 0.75rem;
      color: #4b5563;
   }

   .groupsStatus {
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 0.65rem;
      font-size: 0.8rem;
      color: #4b5563;
   }

   .groupsStatus.error {
      color: #b91c1c;
      border-color: #fecaca;
      background: #fff1f2;
   }

   .groupsChecklist {
      display: flex;
      flex-direction: column;
      gap: 0.45rem;
      max-height: 260px;
      overflow: auto;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 0.5rem;
      background: #fff;
   }

   .groupItem {
      display: flex;
      gap: 0.5rem;
      align-items: flex-start;
      padding: 0.35rem 0.2rem;
      border-bottom: 1px dashed #e5e7eb;
   }

   .groupItem:last-child {
      border-bottom: none;
   }

   .groupItem input {
      margin-top: 0.2rem;
   }

   .groupMeta {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
      min-width: 0;
   }

   .groupName {
      font-size: 0.82rem;
      color: #111827;
      font-weight: 600;
      word-break: break-word;
   }

   .groupJid {
      font-size: 0.72rem;
      color: #6b7280;
      word-break: break-all;
   }

   .groupMembers {
      font-size: 0.7rem;
      color: #6b7280;
   }

   .sectionError {
      color: #b91c1c;
      background: #fff1f2;
      border: 1px solid #fecaca;
      border-radius: 8px;
      padding: 0.6rem;
      font-size: 0.8rem;
   }

   .variables-info {
      background: #f9f9f9;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 1rem;
   }

   .variable-list {
      margin-top: 0.75rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
   }

   .variable-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      background: #fff;
      border-radius: 4px;
      font-size: 0.75rem;

      .variable-name {
         color: #333;
         font-weight: 500;
      }

      code {
         background: #e0e7ff;
         padding: 0.25rem 0.5rem;
         border-radius: 4px;
         font-family: 'Courier New', monospace;
         color: #3730a3;
         font-size: 0.7rem;
      }
   }

   .info-box {
      background: #f0f9ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      padding: 1rem;

      p {
         margin: 0;
         font-size: 0.75rem;
         color: #666;
         line-height: 1.5;

         & + p {
            margin-top: 0.5rem;
         }
      }
   }

   .copy-button {
      background: #3b82f6;
      color: white;
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.2s;

      &:hover {
         background: #2563eb;
      }

      &.copied {
         background: #10b981;
      }
   }
`;
